// ═══════════════════════════════════════════════════════════════════════════════
//  src/interview/InterviewReport.jsx
//  INTERVIEW ROOM — el reporte
//
//  El producto no es la pregunta suelta: es esto. Salir sabiendo en qué fase te
//  quiebras — que casi nunca es la que uno cree. Mucha gente sale de una
//  entrevista pensando que falló en lo técnico cuando en realidad se cayó en la
//  fase de conducta, o al revés.
//
//  Todo lo que se muestra aquí se calculó en el servidor con aritmética, no con
//  IA: promedios y desglose por fase. Pagarle a un modelo por promediar números
//  sería absurdo, y además el número tiene que ser el mismo cada vez que el
//  alumno abra el reporte.
// ═══════════════════════════════════════════════════════════════════════════════

const PHASE_COLOR = {
  // Leen del tema. Antes eran hexadecimales fijos de modo oscuro, duplicados
  // en dos archivos: en claro habrian pintado neones sobre gris.
  icebreaker: 'var(--iv-ph-icebreaker)',
  background: 'var(--iv-ph-background)',
  technical: 'var(--iv-ph-technical)',
  behavioral: 'var(--iv-ph-behavioral)',
  closing: 'var(--iv-ph-closing)',
};

export default function InterviewReport({ report, onAgain, onExit }) {
  const score = report.overall_score;
  const phases = report.phase_scores || [];
  const weakest = phases.length
    ? phases.reduce((a, b) => (b.score < a.score ? b : a))
    : null;

  return (
    <div className="iv-screen iv-report">
      <span className="iv-lbl" style={{ marginTop: '1.6rem' }}>Entrevista terminada</span>
      <p className="iv-grade iv-num">
        {score === null || score === undefined ? '—' : Math.round(score)}
      </p>
      <p className="iv-lbl">
        {report.role_label} · {report.answered} de {report.question_count} respondidas
      </p>

      {phases.length > 0 && (
        <div className="iv-bars">
          {phases.map((p) => (
            <div key={p.id} className="iv-bar-row">
              <span className="iv-bar-k">{p.label}</span>
              <span className="iv-bar-t">
                <span
                  className="iv-bar-f"
                  style={{ width: `${Math.max(2, p.score)}%`, background: PHASE_COLOR[p.id] || 'var(--iv-ac)' }}
                />
              </span>
              <span className="iv-bar-v iv-num">{Math.round(p.score)}</span>
            </div>
          ))}
        </div>
      )}

      {weakest && (
        <div className="iv-verdict iv-mid" style={{ textAlign: 'left' }}>
          <span className="iv-lbl">Por dónde empezar</span>
          <p className="iv-said">
            Tu fase más floja fue <b>{weakest.label}</b> con {Math.round(weakest.score)} de 100.
            Repite la entrevista atacando esa parte: es la que más te cuesta puntos
            y la que menos gente practica.
          </p>
          {report.strengths?.length > 0 && (
            <ul className="iv-list">
              {report.strengths.map((s) => <li key={s} className="iv-plus">Sólido en {s}</li>)}
            </ul>
          )}
        </div>
      )}

      {report.turns?.length > 0 && (
        <div className="iv-bars" style={{ marginTop: '1.6rem' }}>
          <span className="iv-lbl">Pregunta por pregunta</span>
          {report.turns.map((t) => (
            <div key={t.index} className="iv-plan-row" style={{ '--iv-mc': PHASE_COLOR[t.phase] || 'var(--iv-ac)' }}>
              <span style={{ fontSize: '.76rem', lineHeight: 1.45 }}>
                {t.index}. {t.question_en}
              </span>
              <b className="iv-num">{t.score === null || t.score === undefined ? '—' : Math.round(t.score)}</b>
            </div>
          ))}
        </div>
      )}

      <div className="iv-actions">
        <button type="button" className="iv-btn" onClick={onAgain}>Otra entrevista →</button>
        <button type="button" className="iv-btn iv-btn-ghost" onClick={onExit}>Volver al gimnasio</button>
      </div>
    </div>
  );
}
